import { JuryMemberCard } from '../../components/juryMemberCard/juryMemberCard.component'

import femaleSVG from '../../assets/images/female.svg'
import maleSVG from '../../assets/images/male.svg'
import { useEffect, useState } from 'react'
import { getJuryDetails } from '../../services/users.service'
import { useDispatch, useSelector } from 'react-redux'
import { juryAboutDataActions } from '../../store/juryAbout'
import { useNavigate } from 'react-router-dom'

export const JuryMemberList = () => {
    const [juryListData, setJuryListData] = useState([])
    const juryAboutIndex = useSelector(state => state.juryAbout.index)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const getJuryList = async () => {
        const { status, data } = await getJuryDetails()
        if (status == 200) {
            const { juryData } = data
            setJuryListData(juryData)
            dispatch(juryAboutDataActions.setData(juryData[juryAboutIndex]))

        }
    }
    const setJuryDetails = (id) => {
        dispatch(juryAboutDataActions.setData(juryListData[id]))
        dispatch(juryAboutDataActions.setIndex(id))
        navigate("/jury-details")
    }
    useEffect(() => {
        getJuryList()
    }, [])
    // return (
    //     <div>
    //         <h4 className="mb-0 mt-1">JURY MEMBERS</h4>
    //         <h4 className="opacity-50">{juryListData.length} members</h4>
    //         {
    //             juryListData.map((data, index) => {
    //                 return <JuryMemberCard key={index} id={index} image={maleSVG} name={data.NAME} setJuryDetails={setJuryDetails} />
    //             })
    //         }
    //     </div>
    // )

    return (
        <div className="card">
            <div className="card-body h-300p">
                <h2 className="text-uppercase mb-5">
                    <span className="star-orange">jury</span> members
                </h2>
                <p className="opacity-50 font-12">{juryListData.length} Members</p>
                <div className="overflow-auto h-200p">
                {
                    juryListData.map((data, index) => {
                        return <JuryMemberCard key={index} id={index} image={maleSVG} name={data.NAME} setJuryDetails={setJuryDetails} />
                    })
                }
                </div>
            </div>
        </div>

    )
}